export default "__VITE_ASSET__CdTxYxoJ__"